import React from "react";

export const MagnifierIcon = (): JSX.Element => {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 14l4 4"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 9A7 7 0 112 9a7 7 0 0114 0z" stroke="#fff" strokeWidth={2} />
    </svg>
  );
};
